/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ProjectPermissionInfo,
  RuntimeStatus,
  SchedulerSessions200Response,
  SubscriptionDefaultValues,
  SupportedCurrency,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ProjectPermissionInfoFromJSON,
    ProjectPermissionInfoToJSON,
    RuntimeStatusFromJSON,
    RuntimeStatusToJSON,
    SchedulerSessions200ResponseFromJSON,
    SchedulerSessions200ResponseToJSON,
    SubscriptionDefaultValuesFromJSON,
    SubscriptionDefaultValuesToJSON,
    SupportedCurrencyFromJSON,
    SupportedCurrencyToJSON,
} from '../models/index';

export interface EnqueueIntegrationRequest {
    integrationId: string;
}

export interface EnqueueProjectPrecalculationRequest {
    projectId: string;
}

export interface SchedulerSessionsRequest {
    page?: number;
    state?: SchedulerSessionsStateEnum;
    projectId?: string | null;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * Creates request options for applicationOpenAPISpecification without sending the request
     */
    async applicationOpenAPISpecificationRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/openapi`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecificationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.applicationOpenAPISpecificationRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecification(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.applicationOpenAPISpecificationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for applicationStatus without sending the request
     */
    async applicationStatusRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RuntimeStatus>> {
        const requestOptions = await this.applicationStatusRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RuntimeStatusFromJSON(jsonValue));
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RuntimeStatus> {
        const response = await this.applicationStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for debugException without sending the request
     */
    async debugExceptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/debug/exception`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throws a runtime exception for Tracy logging verification.
     */
    async debugExceptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.debugExceptionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Throws a runtime exception for Tracy logging verification.
     */
    async debugException(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.debugExceptionRaw(initOverrides);
    }

    /**
     * Creates request options for defaultSubscriptionValues without sending the request
     */
    async defaultSubscriptionValuesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/subscription-default-values`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDefaultValues>> {
        const requestOptions = await this.defaultSubscriptionValuesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionDefaultValuesFromJSON(jsonValue));
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDefaultValues> {
        const response = await this.defaultSubscriptionValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for enqueueIntegration without sending the request
     */
    async enqueueIntegrationRequestOpts(requestParameters: EnqueueIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling enqueueIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/integration/{integrationId}`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Schedules a manual project run limited to the selected integration.
     */
    async enqueueIntegrationRaw(requestParameters: EnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.enqueueIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Schedules a manual project run limited to the selected integration.
     */
    async enqueueIntegration(requestParameters: EnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.enqueueIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for enqueueProjectPrecalculation without sending the request
     */
    async enqueueProjectPrecalculationRequestOpts(requestParameters: EnqueueProjectPrecalculationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling enqueueProjectPrecalculation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/precalculation/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Schedules a manual rebuild of published project data without fetch jobs.
     */
    async enqueueProjectPrecalculationRaw(requestParameters: EnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.enqueueProjectPrecalculationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Schedules a manual rebuild of published project data without fetch jobs.
     */
    async enqueueProjectPrecalculation(requestParameters: EnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.enqueueProjectPrecalculationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectPermissions without sending the request
     */
    async projectPermissionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project-permission`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectPermissionInfo>> {
        const requestOptions = await this.projectPermissionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPermissionInfoFromJSON(jsonValue));
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectPermissionInfo> {
        const response = await this.projectPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for schedulerSessions without sending the request
     */
    async schedulerSessionsRequestOpts(requestParameters: SchedulerSessionsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/sessions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns paginated scheduler sessions with nested fetch jobs for admin overview.
     */
    async schedulerSessionsRaw(requestParameters: SchedulerSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SchedulerSessions200Response>> {
        const requestOptions = await this.schedulerSessionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulerSessions200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated scheduler sessions with nested fetch jobs for admin overview.
     */
    async schedulerSessions(requestParameters: SchedulerSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SchedulerSessions200Response> {
        const response = await this.schedulerSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for supportedCurrencies without sending the request
     */
    async supportedCurrenciesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/supported-currencies`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrenciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportedCurrency>>> {
        const requestOptions = await this.supportedCurrenciesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportedCurrencyFromJSON));
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrencies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportedCurrency>> {
        const response = await this.supportedCurrenciesRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SchedulerSessionsStateEnum = {
    All: 'all',
    Scheduled: 'scheduled',
    Running: 'running',
    Completed: 'completed'
} as const;
export type SchedulerSessionsStateEnum = typeof SchedulerSessionsStateEnum[keyof typeof SchedulerSessionsStateEnum];
